import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import rootReducer from "./reducers";
import rootSaga from "./sagas";

const sagaMiddleware = createSagaMiddleware();

const composeWithDevTools =
  process.env.NODE_ENV === 'development' ? ((window as any)["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"] as typeof compose) ||
    compose : compose;


const store = (preloadedState?: any) => {
  return {
    ...createStore(
      rootReducer(),
      preloadedState,
      composeWithDevTools(
        applyMiddleware(sagaMiddleware)
      )
    ),
    runSaga: sagaMiddleware.run(rootSaga),
  };
};

export default store;
